import React from 'react';
import PropTypes from 'prop-types';
import { CorePageParams } from 'site-modules/shared/utils/core-page/params';
import { generateNewFlatUrl, generateSrpLinkMakeModel } from 'site-modules/shared/utils/srp-link-constructor';
import { DockedContainer } from 'site-modules/shared/components/docked-container/docked-container';
import { ShoppingLink } from 'site-modules/shared/components/shopping-link/shopping-link';

import './docked-srp-link.scss';

export function DockedSrpLink({
  params,
  showElementSelector,
  inventoryTotalNumber = null,
  creativeId = null,
  trackingId = null,
  makeName = null,
  modelName = null,
  core7007Recipe = 'ctrl',
}) {
  const { make, model, isDealerlessOem } = params;

  if (isDealerlessOem && !inventoryTotalNumber) {
    return null;
  }

  const core7007LabelMap = {
    ctrl: 'See All for Sale',
    chal1: `Find your new ${makeName} ${modelName}`,
    chal2: `See ${makeName} ${modelName} Inventory`,
  };

  const srpLinkProps = isDealerlessOem
    ? {
        to: generateSrpLinkMakeModel(make, model),
        label: core7007Recipe.includes('chal') ? 'See All for Sale' : 'See Used for Sale',
      }
    : {
        to: generateNewFlatUrl({ make, model }),
        label: core7007LabelMap[core7007Recipe],
      };

  return (
    <DockedContainer showElementSelector={showElementSelector}>
      <ShoppingLink
        data-tracking-id={trackingId}
        creativeId={creativeId}
        className="docked-srp-link px-1 py-0_75 bg-white rounded"
        iconClassName="icon-price-tags2"
        iconStyles={{ height: '40px', width: '40px' }}
        {...srpLinkProps}
      />
    </DockedContainer>
  );
}

DockedSrpLink.propTypes = {
  params: CorePageParams.isRequired,
  showElementSelector: PropTypes.string.isRequired,
  creativeId: PropTypes.string,
  trackingId: PropTypes.string,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
  inventoryTotalNumber: PropTypes.number,
  core7007Recipe: PropTypes.string,
};
